// Colour per emotion family (DESIGN-DECISIONS §4).
//
// Hue carries the editor's verb, not just a category: delighted and struck are
// the two you want more of and read warm; provoked is the one to check was
// intended; lost is the one to fix, and gets the coldest, least flattering
// colour so a wall of it is unmissable on the timeline.
//
// The keys must match icons.family values exactly. Unknown families fall back to
// grey rather than throwing — a genre pack added by INSERT (spec §6.4) must not
// be able to crash the dashboard before anyone gets round to picking it a colour.
export const familyColorScale: Record<string, string> = {
  delighted: '#f0b429',
  struck: '#5b8def',
  provoked: '#e0574f',
  lost: '#7c869c'
};
